import { render, staticRenderFns } from "./LazadaProductForm.vue?vue&type=template&id=64ead220"
import script from "./LazadaProductForm.vue?vue&type=script&lang=js"
export * from "./LazadaProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports